const DEFAULT_HOST = 'localhost:2567';

function envHost(): string {
  return import.meta.env.VITE_SERVER_HOST ?? DEFAULT_HOST;
}

function pageIsSecure(): boolean {
  return typeof location !== 'undefined' && location.protocol === 'https:';
}

export function getServerHost(raw?: string): string {
  return (raw ?? envHost()).replace(/^(https?|wss?):\/\//, '');
}

export function getHttpServerUrl(host?: string, secure: boolean = pageIsSecure()): string {
  return `${secure ? 'https' : 'http'}://${getServerHost(host)}`;
}

export function getWsServerUrl(host?: string, secure: boolean = pageIsSecure()): string {
  return `${secure ? 'wss' : 'ws'}://${getServerHost(host)}`;
}
